// Sets the sessionId to the input string
export const setSessionId = (newSessionId: string) => {
  window.sessionStorage.setItem("sessionId", newSessionId);
};
